export const geoDiscountConfig = {
  US: { discount: 60, currency: 'USD', description: '60OFFUSD' },
  // IN: { discount: 67, currency: 'INR', description: 'BTSINDIA', coupon_code: 'BTSINDIA' },
  BR: { discount: 67, currency: 'BRL', description: '67OFFBRL' },
};

export const bannerMessages = {
  IN: "Exclusive Back-to-School Offer — {discount}% Limited Coupons! Hurry Before They're Gone",
  DEFAULT:
    "Exclusive Back-to-School Offer — {discount}% Limited Coupons! Hurry Before They're Gone",
};

// Black Friday Campaign Configuration
export const blackFridayConfig = {
  // Differential Countries (78% OFF)
  IN: {
    discount: 78,
    isDifferential: true,
    saleType: 'Black Friday',
  },
  BR: {
    discount: 78,
    isDifferential: true,
    saleType: 'Black Friday',
  },

  // MENA Countries (White Friday 50% OFF)
  AZ: {
    // Azerbaijan
    discount: 50,
    isDifferential: false,
    saleType: 'White Friday',
  },
  BH: {
    // Bahrain
    discount: 50,
    isDifferential: false,
    saleType: 'White Friday',
  },
  IQ: {
    // Iraq
    discount: 50,
    isDifferential: false,
    saleType: 'White Friday',
  },
  JO: {
    // Jordan
    discount: 50,
    isDifferential: false,
    saleType: 'White Friday',
  },
  KW: {
    // Kuwait
    discount: 50,
    isDifferential: false,
    saleType: 'White Friday',
  },
  LB: {
    // Lebanon
    discount: 50,
    isDifferential: false,
    saleType: 'White Friday',
  },
  OM: {
    // Oman
    discount: 50,
    isDifferential: false,
    saleType: 'White Friday',
  },
  PS: {
    // Palestine
    discount: 50,
    isDifferential: false,
    saleType: 'White Friday',
  },
  QA: {
    // Qatar
    discount: 50,
    isDifferential: false,
    saleType: 'White Friday',
  },
  SA: {
    // Saudi Arabia
    discount: 50,
    isDifferential: false,
    saleType: 'White Friday',
  },
  SY: {
    // Syria
    discount: 50,
    isDifferential: false,
    saleType: 'White Friday',
  },
  TR: {
    // Turkey or Turkiye
    discount: 50,
    isDifferential: false,
    saleType: 'White Friday',
  },
  AE: {
    // United Arab Emirates
    discount: 50,
    isDifferential: false,
    saleType: 'White Friday',
  },

  // Excluded Countries (No Banner)
  CN: { exclude: true },
  JP: { exclude: true },
  KR: { exclude: true }, // Korea

  // Non-Differential Countries (50% OFF)
  US: {
    discount: 50,
    isDifferential: false,
    saleType: 'Black Friday',
  },
  UK: {
    discount: 50,
    isDifferential: false,
    saleType: 'Black Friday',
  },
  CA: {
    discount: 50,
    isDifferential: false,
    saleType: 'Black Friday',
  },
  AU: {
    discount: 50,
    isDifferential: false,
    saleType: 'Black Friday',
  },

  DEFAULT: {
    discount: 50,
    isDifferential: false,
    saleType: 'Black Friday',
  },
};

export const blackFridayBannerMessages = {
  // Product Page Messages
  productPage: {
    differential:
      '{saleType} Mega Sale! Our Biggest Deal of the Year — <b>{discount}% OFF</b> at checkout!',
    nonDifferential:
      '{saleType} Mega Sale! Our Biggest Deal of the Year — <b>Extra {discount}% OFF</b> at checkout!',
    whiteFriday:
      '{saleType} Mega Sale! Our Biggest Deal of the Year — <b>Extra {discount}% OFF</b> at checkout!',
  },

  // Upgrade Modal Messages (shorter versions)
  upgradeModal: {
    differential: '{saleType} Mega Sale — <b>{discount}% OFF</b> at checkout!',
    nonDifferential: '{saleType} Mega Sale — <b>Extra {discount}% OFF</b> at checkout!',
    whiteFriday: '{saleType} Mega Sale — <b>Extra {discount}% OFF</b> at checkout!',
  },

  // CTA Text
  cta: 'Get the Offer',
};

// ============================================
// Christmas & New Year Campaign: Dec 18 - Dec 31, 2025
// ============================================
// ============================================
// Christmas & New Year Campaign: Dec 18 - Dec 31, 2025
// ============================================
export const christmasNewYearConfig = {
  // Differential Countries (74% OFF) - India and Brazil
  IN: {
    discount: 75,
    isDifferential: true,
    saleType: 'Christmas & New Year Special',
  },
  BR: {
    discount: 75,
    isDifferential: true,
    saleType: 'Christmas & New Year Special',
  },

  // Excluded Countries (No Banner)
  CN: { exclude: true },
  JP: { exclude: true },
  KR: { exclude: true },

  // Non-Differential Countries (30% OFF)
  US: {
    discount: 30,
    isDifferential: false,
    saleType: 'Christmas & New Year Special',
  },
  UK: {
    discount: 30,
    isDifferential: false,
    saleType: 'Christmas & New Year Special',
  },
  CA: {
    discount: 30,
    isDifferential: false,
    saleType: 'Christmas & New Year Special',
  },
  AU: {
    discount: 30,
    isDifferential: false,
    saleType: 'Christmas & New Year Special',
  },

  DEFAULT: {
    discount: 30,
    isDifferential: false,
    saleType: 'Christmas & New Year Special',
  },
};
// ============================================
// Winter Sale Campaign: Feb 16 - Feb 28, 2026
// ============================================
export const winterSaleConfig = {
  // Differential Countries (75% OFF) - India and Brazil
  IN: {
    discount: 75,
    isDifferential: true,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  BR: {
    discount: 75,
    isDifferential: true,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },

  // Non-Differential Countries (30% OFF on Annual packs) - US, LATAM, AU
  US: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  AU: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  NZ: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  // LATAM countries
  AR: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  BS: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  BB: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  BM: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  BO: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  KY: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  CL: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  CO: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  CR: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  DM: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  DO: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  EC: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  SV: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  GD: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  GT: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  GY: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  JM: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  MX: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  MS: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  PA: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  PY: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  PE: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  PR: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  VC: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  TT: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  UY: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  LC: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },
  VG: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual packs',
  },

  // Non-Differential Countries (30% OFF on Annual & Quarterly packs) - UK, Middle East, EU
  UK: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  // Middle East
  AE: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  TR: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  SA: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  QA: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  OM: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  LB: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  KW: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  JO: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  IQ: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  BH: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  AZ: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  SY: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  PS: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  // EU
  UZ: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  UA: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  CH: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  SE: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  ES: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  SI: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  RS: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  RU: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  RO: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  PT: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  PL: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  NO: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  NL: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  MK: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  LU: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  KZ: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  JE: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  IT: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  IL: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  IS: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  HU: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  GR: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  DE: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  GE: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  FR: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  FI: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  DK: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  CZ: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  BG: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  BE: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  AT: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  AD: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  AL: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  XK: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  SK: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  MT: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  LT: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  LV: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  EE: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  CY: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
  HR: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },

  // Excluded Co  untries (No Banner)
  CN: { exclude: true },
  JP: { exclude: true },
  KR: { exclude: true },

  DEFAULT: {
    discount: 30,
    isDifferential: false,
    saleType: 'Winter Special Sale',
    packs: 'Annual & Quarterly packs',
  },
};

export const winterSaleBannerMessages = {
  // Product Page Messages
  productPage: {
    differential: '{saleType} — Get {discount}% OFF on {packs} at Checkout. Limited Time Only!',
    nonDifferential:
      '{saleType} — Get Additional {discount}% OFF on {packs} at Checkout. Limited Time Only!',
  },

  // Upgrade Modal Messages (shorter versions)
  upgradeModal: {
    differential: '{saleType} — Get {discount}% OFF on {packs} at Checkout. Limited Time Only!',
    nonDifferential:
      '{saleType} — Get Additional {discount}% OFF on {packs} at Checkout. Limited Time Only!',
  },

  // CTA Text
  cta: 'Get the Offer',
};

// Campaign date helper
export const isWinterSaleCampaignActive = () => {
  const now = new Date();
  const startDate = new Date('2026-02-12T00:00:00');
  const endDate = new Date('2026-02-28T23:59:59');
  return now <= endDate;
};

export const christmasNewYearBannerMessages = {
  // Product Page Messages
  productPage: {
    differential:
      'Celebrate the Holidays with Our {saleType} Sale — <b>{discount}% OFF</b> at checkout, Limited Time!',
    nonDifferential:
      'Celebrate the Holidays with Our {saleType} Sale — <b>Extra {discount}% OFF</b> at checkout, Limited Time!',
  },

  // Upgrade Modal Messages (shorter versions)
  upgradeModal: {
    differential: '{saleType} Sale — <b>{discount}% OFF</b> at checkout, Limited Time!',
    nonDifferential: '{saleType} Sale — <b>Extra {discount}% OFF</b> at checkout, Limited Time!',
  },

  // CTA Text
  cta: 'Get the Offer',
};

// Campaign date helper
export const isChristmasNewYearCampaignActive = () => {
  const now = new Date();
  const startDate = new Date('2025-12-18T00:00:00');
  const endDate = new Date('2025-12-31T23:59:59');
  return now >= startDate && now <= endDate;
};

// ============================================
// New Year Writing Resolutions Campaign: Jan 19 - Jan 31, 2026
// ============================================

// MENA/Middle East countries list
const MENA_COUNTRIES = [
  'AZ',
  'BH',
  'IQ',
  'JO',
  'KW',
  'LB',
  'OM',
  'PS',
  'QA',
  'SA',
  'SY',
  'TR',
  'AE',
];

// EU countries list
const EU_COUNTRIES = [
  'AT', // Austria
  'BE', // Belgium
  'BG', // Bulgaria
  'HR', // Croatia
  'CY', // Cyprus
  'CZ', // Czech Republic
  'DK', // Denmark
  'EE', // Estonia
  'FI', // Finland
  'FR', // France
  'DE', // Germany
  'GR', // Greece
  'HU', // Hungary
  'IE', // Ireland
  'IT', // Italy
  'LV', // Latvia
  'LT', // Lithuania
  'LU', // Luxembourg
  'MT', // Malta
  'NL', // Netherlands
  'PL', // Poland
  'PT', // Portugal
  'RO', // Romania
  'SK', // Slovakia
  'SI', // Slovenia
  'ES', // Spain
  'SE', // Sweden
];

// Non-EU European countries list
const NON_EU_COUNTRIES = [
  'AL', // Albania
  'AD', // Andorra
  'AM', // Armenia
  'AZ', // Azerbaijan
  'BY', // Belarus
  'BA', // Bosnia and Herzegovina
  'GE', // Georgia
  'IS', // Iceland
  'XK', // Kosovo
  'LI', // Liechtenstein
  'MD', // Moldova
  'MC', // Monaco
  'ME', // Montenegro
  'MK', // North Macedonia
  'NO', // Norway
  'SM', // San Marino
  'RS', // Serbia
  'CH', // Switzerland
  'UA', // Ukraine
  'GB', // United Kingdom
  'VA', // Vatican City
];

// LATAM countries list
const LATAM_COUNTRIES = [
  'AR', // Argentina
  'BO', // Bolivia
  'BZ', // Belize
  'CL', // Chile
  'CO', // Colombia
  'CR', // Costa Rica
  'CU', // Cuba
  'DO', // Dominican Republic
  'EC', // Ecuador
  'SV', // El Salvador
  'GT', // Guatemala
  'HN', // Honduras
  'MX', // Mexico
  'NI', // Nicaragua
  'PA', // Panama
  'PY', // Paraguay
  'PE', // Peru
  'PR', // Puerto Rico
  'UY', // Uruguay
  'VE', // Venezuela
];

export const newYearResolutionsConfig = {
  // India - Republic Day Sale (Differential with 75% OFF)
  IN: {
    discount: 75,
    isDifferential: true,
    saleType: 'Republic Day',
    couponCode: 'REPUBLIC2026',
    couponDiscount: 20, // Additional 20% on top of differential
  },

  // Excluded Countries (No Banner)
  CN: { exclude: true },
  JP: { exclude: true },
  KR: { exclude: true },

  // Non-Differential Countries with 30% OFF
  // UK
  GB: {
    discount: 30,
    isDifferential: false,
    saleType: 'New Year',
    couponCode: 'NY2026',
  },
  UK: {
    discount: 30,
    isDifferential: false,
    saleType: 'New Year',
    couponCode: 'NY2026',
  },

  // US, LATAM, Australia
  US: {
    discount: 30,
    isDifferential: false,
    saleType: 'New Year',
    couponCode: 'PPNY',
  },
  AU: {
    discount: 30,
    isDifferential: false,
    saleType: 'New Year',
    couponCode: 'PPNY',
  },

  DEFAULT: {
    discount: 30, // Will be determined dynamically
    isDifferential: true, // Will be determined dynamically
    saleType: 'New Year',
  },
};

// Dynamically add MENA countries
MENA_COUNTRIES.forEach((country) => {
  newYearResolutionsConfig[country] = {
    discount: 30,
    isDifferential: false,
    saleType: 'New Year',
    couponCode: 'NY2026',
  };
});

// Dynamically add EU countries
EU_COUNTRIES.forEach((country) => {
  newYearResolutionsConfig[country] = {
    discount: 30,
    isDifferential: false,
    saleType: 'New Year',
    couponCode: 'NY2026',
  };
});

// Dynamically add Non-EU European countries
NON_EU_COUNTRIES.forEach((country) => {
  newYearResolutionsConfig[country] = {
    discount: 30,
    isDifferential: false,
    saleType: 'New Year',
    couponCode: 'NY2026',
  };
});

// Dynamically add LATAM countries
LATAM_COUNTRIES.forEach((country) => {
  // Brazil gets differential pricing with NY20 coupon
  if (country === 'BR') {
    newYearResolutionsConfig[country] = {
      discount: 75,
      isDifferential: true,
      saleType: 'New Year',
      couponCode: 'NY20',
      couponDiscount: 20, // Additional 20% on top of differential
    };
  } else {
    // Other LATAM countries get non-differential pricing with PPNY coupon
    newYearResolutionsConfig[country] = {
      discount: 30,
      isDifferential: false,
      saleType: 'New Year',
      couponCode: 'PPNY',
    };
  }
});

// DEFAULT to handle other differential countries (non-India, non-Brazil)
// Other differential countries get 75% off with NY20 coupon
newYearResolutionsConfig.DEFAULT = {
  discount: 75,
  isDifferential: true,
  saleType: 'New Year',
  couponCode: 'NY20',
  couponDiscount: 20,
};

export const newYearResolutionsBannerMessages = {
  // Product Page Messages
  productPage: {
    india: 'Republic Day Sale! Enjoy up to 75% OFF on select plans at checkout. Limited-time only!',
    differentialNonIndia:
      'This New Year, elevate your scientific visuals! Enjoy up to 75% OFF on select plans at checkout — for a limited time only.',
    nonDifferential:
      'This New Year, elevate your scientific visuals! Enjoy an Additional 30% OFF on select plans at checkout — for a limited time only.',
  },

  // Upgrade Modal Messages (shorter versions)
  upgradeModal: {
    india: 'Republic Day Sale! Enjoy up to 75% OFF on select plans at checkout. Limited-time only!',
    differentialNonIndia:
      'This New Year, elevate your scientific visuals! Enjoy up to 75% OFF on select plans at checkout — for a limited time only.',
    nonDifferential:
      'This New Year, elevate your scientific visuals! Additional 30% OFF on select plans at checkout — for a limited time only.',
  },

  // CTA Text
  cta: 'Get the Offer',
};

// Helper function to determine message type
export const getNewYearMessageType = (countryCode, isDifferential) => {
  if (countryCode === 'IN') {
    return 'india';
  } else if (isDifferential) {
    return 'differentialNonIndia';
  } else {
    return 'nonDifferential';
  }
};

// Campaign date helper
export const isNewYearResolutionsCampaignActive = () => {
  const now = new Date();
  const startDate = new Date('2026-01-19T00:00:00');
  const endDate = new Date('2026-01-31T23:59:59');
  return now >= startDate && now <= endDate;
};
